import { Input, Injector, OnInit, OnChanges, SimpleChanges, Type, Directive } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormControl, ValidatorFn, ControlContainer } from '@angular/forms';

import { ConfirmDialogService } from '../services';

@Directive()
export abstract class EditEntityChildBaseComponent implements OnInit, OnChanges {

    protected dialogService: ConfirmDialogService;
    protected controlContainer: ControlContainer;
    protected route: ActivatedRoute;

    @Input()
    public entity: any;

    public entityForm: FormGroup;

    @Input()
    public errors: Array<string> = [];

    constructor(injector: Injector) {
        this.dialogService = injector.get(ConfirmDialogService);
        this.controlContainer = injector.get(ControlContainer);
        this.route = injector.get(ActivatedRoute);
    }

    ngOnInit() {
        const parentForm = this.controlContainer.control as FormGroup;
        const form = this.createEntityForm();
        for (const controlName of Object.keys(form.controls)) {
            parentForm.addControl(controlName, form.controls[controlName]);
        }
        this.entityForm = parentForm;
        this.loadEntity(this.entity);
    }

    ngOnChanges(change: SimpleChanges) {
        if (change.entity && !change.entity.isFirstChange()) {
            this.loadEntity(change.entity.currentValue);
        }
    }

    abstract createEntityForm(): FormGroup;

    abstract loadEntity(entity: any): void;

    protected arrayMinLength(size: number): ValidatorFn {
        return (c: FormControl) => {
            return c.value.length >= size ? null : {
                minlength: {
                    valid: false
                }
            };
        };
    }

    protected number(prms: any): ValidatorFn {
        return (c: FormControl) => {
            const value: number = c.value;
            if (value === null || isNaN(value) || /^\d+(.\d{1,2})?$/.test(value.toString()) === false) {
                return { number: true };
            } else if (!isNaN(prms.min) && !isNaN(prms.max)) {
                return value < prms.min || value > prms.max ? { number: true } : null;
            } else if (!isNaN(prms.min)) {
                return value < prms.min ? { number: true } : null;
            } else if (!isNaN(prms.max)) {
                return value > prms.max ? { number: true } : null;
            }
        };
    }

    public remove(array: FormArray, formControl: FormGroup): void {
        this.dialogService.confirm('Are you sure you want to delete this item?')
            .then((result) => {
                if (result) {
                    const index = array.controls.indexOf(formControl);
                    array.removeAt(index);
                    array.markAsDirty();
                }
            });
    }
}
